const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

// hospitalWardList
const UPDATE_HOSPITALWARDLIST = 'UPDATE_HOSPITALWARDLIST';
const DELETE_HOSPITALWARDLIST = 'DELETE_HOSPITALWARDLIST';

// wardInfo
const UPDATE_WARDINFO = 'UPDATE_WARDINFO';
const GET_WARDINFO = 'GET_WARDINFO';

// userRole
const GET_USERROLE = 'GET_USERROLE';
const UPDATE_USERROLE = 'UPDATE_USERROLE';

// loginInfo
const GET_LOGININFO = 'GET_LOGININFO';
const UPDATE_LOGININFO = 'UPDATE_LOGININFO';
const INIT_LOGIN_INFO = 'INIT_LOGIN_INFO';

// globalMonitor
const SCREEN_RESIZE = 'SCREEN_RESIZE';
// BedStatus
const GET_ALL_BEDSTATUS = 'GET_ALL_BEDSTATUS';
const UPDATE_BEDSTATUS = 'UPDATE_BEDSTATUS';
// BedStatus
const GET_ALL_BOOKING = 'GET_ALL_BOOKING';
const CREATE_NEW_BOOKING = 'CREATE_NEW_BOOKING';
const CHANGE_EDIT_BOOKING = 'CHANGE_EDIT_BOOKING';
// pupBooking
const VALUE_PUP_BOOKING = 'VALUE_PUP_BOOKING';
const EMPTY_PUP_BOOKING = 'EMPTY_PUP_BOOKING';

// Ehandover
const UPDATE_NOTE_LIST = 'UPDATE_NOTE_LIST';
const UPDATE_FOLLOW_NOTE_LIST = 'UPDATE_FOLLOW_NOTE_LIST';
const UPDATE_DELETENOTE_LIST = 'UPDATE_DELETENOTE_LIST';
const UPDATE_POSTDAY_LIST = 'UPDATE_POSTDAY_LIST';
const RESET_NOTE_LIST = 'RESET_NOTE_LIST';
const RESET_FOLLOW_NOTE_LIST = 'RESET_FOLLOW_NOTE_LIST';
const RESET_DELETENOTE_LIST = 'RESET_DELETENOTE_LIST';
const RESET_POSTDAY_LIST = 'RESET_POSTDAY_LIST';
const ADD_TOTAL = 'ADD_TOTAL';
const REDUCE_TOTAL = 'REDUCE_TOTAL';
const RESET_TOTAL = 'RESET_TOTAL';
const UPDATE_NOTIFICATION_LIST = 'UPDATE_NOTIFICATION_LIST';
const RESET_NOTIFICATION_LIST = 'RESET_NOTIFICATION_LIST';
const PIN_NOTIFICATION_LIST = 'PIN_NOTIFICATION_LIST';
const SET_EHD_SETTING = 'SET_EHD_SETTING';

const LOADING_SHOW = 'LOADING_SHOW';
const LOADING_HIDE = 'LOADING_HIDE';
const CHANGE_LOGININFO_WARD = 'CHANGE_LOGININFO_WARD';

// dutyassign
const SET_EDIT = 'SET_EDIT';
const SET_UNEDIT = 'SET_UNEDIT';

// rouList
const GET_ROULIST = 'GET_ROULIST';
const UPDATE_ROULIST = 'UPDATE_ROULIST';

// roleMap
const UPDATE_ROLEMAP = 'UPDATE_ROLEMAP';
const DELETE_ROLEMAP = 'DELETE_ROLEMAP';

// notification
const SET_TOTAL = 'SET_TOTAL';
const NOTIFICATION_TOTAL_REFRESH = 'NOTIFICATION_TOTAL_REFRESH';
const NOTIFICATION_SEEN_AND_REFRESH = 'NOTIFICATION_SEEN_AND_REFRESH';
const INIT_FORWARD_LIST = 'INIT_FORWARD_LIST';

// appreciation
const APPRECIATION_SET_TOTAL = 'APPRECIATION_SET_TOTAL';

// re-login handling
const EXPIRY_LOGIN_POP_UP_OPEN = 'EXPIRY_LOGIN_POP_UP_OPEN';
const EXPIRY_LOGIN_POP_UP_CLOSE = 'EXPIRY_LOGIN_POP_UP_CLOSE';
// full screen
const OPEN_FULL_SCREEN = 'OPEN_FULL_SCREEN';
const CLOSE_FULL_SCREEN = 'CLOSE_FULL_SCREEN';
// work flow
export const OPEN_WORKFLOW = 'OPEN_WORKFLOW';
export const CLOSE_WORKFLOW = 'CLOSE_WORKFLOW';

// login popup
const SHOW_LOGIN_POPUP = 'SHOW_LOGIN_POPUP';
const HIDE_LOGIN_POPUP = 'HIDE_LOGIN_POPUP';

// cubicle view
const PLAIN_VIEW = 'Plain View';
const CUBICLE_VIEW = 'Cubicle View';
const CUBICLE_VIEW2 = 'Cubicle View V2';
const GET_BEDSTATUS_VIEW = 'SET_BEDSTATUS_VIEW';
const UPDATE_BEDSTATUS_VIEW = 'UPDATE_BEDSTATUS_VIEW';

// sso
const SET_SSO = 'SET_SSO';

// mask
const OPEN_MASK = 'OPEN_MASK';
const CLOSE_MASK = 'CLOSE_MASK';

// version
const SET_VERSION = 'SET_VERSION';
const OPEN_REFRESH_DIALOG = 'OPEN_REFRESH_DIALOG';
const CLOSE_REFRESH_DIALOG = 'CLOSE_REFRESH_DIALOG';
// actionable
const UPDATE_ACTIONABLE_SETTING = 'UPDATE_ACTIONABLE_SETTING';

// env
const SET_ENV = 'SET_ENV';

export {
  VALUE_PUP_BOOKING,
  EMPTY_PUP_BOOKING,
  GET_ALL_BOOKING,
  CREATE_NEW_BOOKING,
  CHANGE_EDIT_BOOKING,
  GET_ALL_BEDSTATUS,
  UPDATE_BEDSTATUS,
  SCREEN_RESIZE,
  UPDATE_LOGININFO,
  GET_LOGININFO,
  CHANGE_LANGUAGE,
  LOADING_SHOW,
  LOADING_HIDE,
  CHANGE_LOGININFO_WARD,
  UPDATE_WARDINFO,
  GET_WARDINFO,
  SET_EDIT,
  SET_UNEDIT,
  GET_USERROLE,
  UPDATE_USERROLE,
  GET_ROULIST,
  UPDATE_ROULIST,
  INIT_LOGIN_INFO,
  UPDATE_NOTE_LIST,
  UPDATE_FOLLOW_NOTE_LIST,
  UPDATE_DELETENOTE_LIST,
  RESET_NOTE_LIST,
  RESET_FOLLOW_NOTE_LIST,
  RESET_DELETENOTE_LIST,
  ADD_TOTAL,
  REDUCE_TOTAL,
  RESET_TOTAL,
  UPDATE_POSTDAY_LIST,
  RESET_POSTDAY_LIST,
  UPDATE_ROLEMAP,
  DELETE_ROLEMAP,
  UPDATE_HOSPITALWARDLIST,
  DELETE_HOSPITALWARDLIST,
  RESET_NOTIFICATION_LIST,
  UPDATE_NOTIFICATION_LIST,
  PIN_NOTIFICATION_LIST,
  SET_TOTAL,
  NOTIFICATION_TOTAL_REFRESH,
  INIT_FORWARD_LIST,
  EXPIRY_LOGIN_POP_UP_OPEN,
  EXPIRY_LOGIN_POP_UP_CLOSE,
  OPEN_FULL_SCREEN,
  CLOSE_FULL_SCREEN,
  SHOW_LOGIN_POPUP,
  HIDE_LOGIN_POPUP,
  PLAIN_VIEW,
  CUBICLE_VIEW,
  CUBICLE_VIEW2,
  GET_BEDSTATUS_VIEW,
  UPDATE_BEDSTATUS_VIEW,
  SET_SSO,
  OPEN_MASK,
  CLOSE_MASK,
  NOTIFICATION_SEEN_AND_REFRESH,
  SET_VERSION,
  OPEN_REFRESH_DIALOG,
  CLOSE_REFRESH_DIALOG,
  UPDATE_ACTIONABLE_SETTING,
  APPRECIATION_SET_TOTAL,
  SET_ENV,
  SET_EHD_SETTING
};
